export declare const entity: (entity: Entity, serv: Server) => void;
export declare const server: (serv: Server, options: Options) => void;
declare global {
    interface Entity {
    }
}
